/**
 * loginLibs.js
 */
require(['jquery', 'bootstrap', //'es6-shim',
    'devicejs',
    'bootstrap', 'smartmenus', 'smartmenus.bootstrap'
], function () {

});
define("loginLibs", function(){});

